import styled from 'styled-components';
import { Button, Input, Layout, message } from "antd";
import { createElement, ChangeEvent, Component, KeyboardEvent, MouseEvent, Props as ReactProps } from 'react';

import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';

import applyGlobalStyles from '../../applyGlobalStyles';

type Props = ReactProps<HTMLElement> & DependencyProps & StateProps & LocationProps;
type State = {
  email: string;
};

const { Content } = Layout;

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

const StyledContent = styled(Content)`
  padding: 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledInput = styled(Input)`
  margin-bottom: 16px;
  max-width: 400px;
`;

const StyledButton = styled(Button)`
  max-width: 400px;
`;

class InviteRoute extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
    };

    this.onKeyPress = this.onKeyPress.bind(this);
    this.onClickInviteButton = this.onClickInviteButton.bind(this);
  }

  private onKeyPress(e: KeyboardEvent<HTMLInputElement>) {
    try {
      const enterKey = 'Enter';
      if (e.key === enterKey) {
        this.props.dependency.invite.invite(this.state.email);
      }

      message.success('入力したメールアドレスへ招待しました');
    } catch (e) {
      message.error('招待に失敗しました');
    }
  };

  private async onClickInviteButton(e: MouseEvent<HTMLAnchorElement>) {
    try {
      e.preventDefault();
      await this.props.dependency.invite.invite(this.state.email);

      message.success('入力したメールアドレスへ招待しました');
    } catch (e) {
      message.error('招待に失敗しました');
    }
  };

  public render() {
    return (
      <StyledLayout>
        <StyledContent>
          <StyledInput
            placeholder="メールアドレスを入力してください"
            onPressEnter={this.onKeyPress}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ email: e.target.value })}
          />
          <StyledButton type="primary" block={true} onClick={(e: any) => this.onClickInviteButton(e)}>
            メール送信
          </StyledButton>
        </StyledContent>
        {applyGlobalStyles()}
      </StyledLayout>
    )
  }
}

export default InviteRoute;
